// Core libraries
import React from 'react';

// External libs and components
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';

// Internal libs

// Internal components

// Styles hook
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  }),
);

// Props type
type GenerateInvoicesAlertProps = {
  open: boolean;
  onClose: () => void;
  onAccept: () => void;
  invoicesAlreadyGenerated?: boolean;
  invoicesMultipleCurrencies?: boolean;
};

// Component
const GenerateInvoicesAlert = ({
  open,
  onClose,
  onAccept,
  invoicesAlreadyGenerated,
  invoicesMultipleCurrencies,
}: GenerateInvoicesAlertProps) => {
  const styles = useStyles();
  const { t } = useTranslation('admin');

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>{t('invoices.dialog.alert.title')}</DialogTitle>
      <DialogContent>
        {invoicesAlreadyGenerated && (
          <DialogContentText>
            - {t('invoices.dialog.alert.invoicesAlreadyGenerated')}
          </DialogContentText>
        )}
        {invoicesMultipleCurrencies && (
          <DialogContentText>
            - {t('invoices.dialog.alert.invoicesMultipleCurrencies')}
          </DialogContentText>
        )}
        <DialogContentText>{t('invoices.dialog.alert.question')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t('invoices.dialog.alert.back')}
        </Button>
        <Button onClick={onAccept} color="primary" autoFocus>
          {t('invoices.dialog.alert.go')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GenerateInvoicesAlert;
